import React from "react";

const Services = () => {
  // services details
  const services = [
    {
      name: "Web site maintenance and optimization",
      desc: "",
      icon: "images/icono-interactiva.png",
      alt: "tools icon",
    },
    {
      name: "Add interactive website features",
      desc: "",
      icon: "/images/icono-herramientas.png",
      alt: "interactive website icon",
    },
    {
      name: "Improved web positioning",
      desc: "",
      icon: "images/icono-seo.png",
      alt: "seo positioning icon",
    },
    {
      name: "Maintain close relationship with UX design changes",
      desc: "",
      icon: "images/icono-ux.png",
      alt: "UX relationship icon",
    },
    {
      name: "Generate connection with the databases",
      desc: "",
      icon: "images/icono-bd.png",
      alt: "database connection icon",
    },
    {
      name: "Combining information, transforming it and returning it to the user",
      desc: "",
      icon: "images/icono-usuario.png",
      alt: "information exchange icon",
    },
  ];

  return (
    <section id="services" className="section bg-light">
      <div className="container">
        {/* Heading */}
        <p className=" text-center mb-2 wow fadeInUp">
          <span className="bg-primary text-blanco px-2">What I Do?</span>
        </p>
        <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">
          How I can help your next project
        </h2>
        {/* Heading end*/}
        <div className="row gy-5 mt-5">
          {services.length > 0 &&
            services.map((service, index) => (
              <div className="col-sm-6 col-lg-4 wow fadeInUp" key={index}>
                <div className="featured-box text-center px-md-4">
                  <div className="featured-box-icon text-red text-13">
                    {" "}
                    <img 
                      className="img-icon-servicios"
                      src={service.icon}
                      alt={service.alt}
                    />
                  </div>
                  <h3 className="text-6 fw-600 mb-3">{service.name}</h3>
                  <p className="text-muted mb-0">{service.desc} </p>
                </div>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
